const DefaultPriceAlgorithm = require("./DefaultPriceAlgorithm");

const {
  getSolJourneyConfigForJourney,
} = require("../v2/lib/getSolJourneyConfigForJourney");
const { getEcoBonus } = require("../v2/lib/getEcoBonus");
const { getPromoAmount } = require("../v2/lib/getPromoAmount");
const {
  isPromoCodeEndDateValid,
} = require("../helper/isPromoCodeEndDateValid");

class PriceAlgorithmItaly extends DefaultPriceAlgorithm {
  constructor({ roundingPrecision }) {
    super({ roundingPrecision });
  }

  getDiscountAmountForPrice(netPrice, dealLikeObject, appConfig) {
    const { configuration } = appConfig;

    this.validateDealLikeObject(dealLikeObject);

    const { financeSimulation, businessModel } = dealLikeObject;
    const { journey } = financeSimulation;

    const ecoBonus = getEcoBonus(journey, appConfig, businessModel);

    let discountAmount = this.getDiscountAmount(
      [netPrice],
      ecoBonus.enabled ? ecoBonus.governmentDiscountPercentage : 0,
      configuration.app.solJourney.taxPercentage
    );

    if (dealLikeObject.isScrappageSelected) {
      const { scrappage } = getSolJourneyConfigForJourney(
        dealLikeObject.financeSimulation.journey,
        dealLikeObject.businessModel,
        configuration
      );

      discountAmount = this.add([
        discountAmount,
        this.getDiscountAmount(
          [netPrice],
          scrappage.discountPercentage,
          configuration.app.solJourney.taxPercentage
        ),
      ]);
    }

    return discountAmount;
  }

  getPriceAfterDiscount(netPrice, dealLikeObject, appConfig) {
    const { configuration } = appConfig;

    this.validateDealLikeObject(dealLikeObject);

    const discountAmount = this.getDiscountAmountForPrice(
      netPrice,
      dealLikeObject,
      appConfig
    );

    return this.getPrice(
      this.subtract([netPrice, discountAmount]),
      configuration.app.solJourney.taxPercentage
    );
  }

  getDefaultPrice(deal, appConfig, withDiscount = true) {
    const { configuration } = appConfig;

    const netPrice = this.subtract([
      deal.carConfiguration.preconfiguration?.vehicle.netPrice || 0,
      getPromoAmount(deal.financeSimulation?.journey, configuration),
    ]);

    if (!withDiscount) {
      return this.getPrice(
        netPrice,
        configuration.app.solJourney.taxPercentage || 0
      );
    }

    return this.getPriceAfterDiscount(netPrice, deal, appConfig);
  }

  getVehiclePrice(deal, appConfig, isPromoCodeApplicable = false) {
    const { configuration } = appConfig;

    const defaultPrice = this.getDefaultPrice(deal, appConfig, false);
    const optionPrices = this.getPackPrice(deal, appConfig, false);

    let vehiclePrice = this.addPrices([defaultPrice, optionPrices]);

    const { promoCode } = deal.financeSimulation;

    if (
      !!isPromoCodeApplicable &&
      promoCode?.valid &&
      isPromoCodeEndDateValid(promoCode?.endDate)
    ) {
      vehiclePrice = this.subtractPrices([
        vehiclePrice,
        this.getPrice(
          promoCode.discountAmount,
          configuration.app.solJourney.taxPercentage
        ),
      ]);
    }

    vehiclePrice = this.getPriceAfterDiscount(
      vehiclePrice.netPrice,
      deal,
      appConfig
    );

    const accessoryPrices = deal.carConfiguration.accessory.map(accessory =>
      this.getPrice(
        accessory.netPrice,
        configuration.app.solJourney.taxPercentage
      )
    );

    const servicePrices = deal.carConfiguration.service.map(service =>
      this.getPrice(
        service.netPrice,
        configuration.app.solJourney.taxPercentage
      )
    );

    return this.addPrices(
      [vehiclePrice].concat(accessoryPrices, servicePrices)
    );
  }

  /**
   * @param  {} deal
   *
   * Use combinedOptions if available
   * use options if not
   */
  getOptions(deal) {
    const combinedOptions = deal.carConfiguration.combinedOptions;
    if (combinedOptions && combinedOptions.length) return combinedOptions;

    return deal.carConfiguration.options;
  }

  getPackPrice(deal, appConfig, withDiscount = true) {
    const options = this.getOptions(deal);

    return this.addPrices(
      options.map(option =>
        withDiscount
          ? this.getPriceAfterDiscount(option.netPrice, deal, appConfig)
          : this.getPrice(
              option.netPrice,
              appConfig?.configuration?.app?.solJourney?.taxPercentage || 0
            )
      )
    );
  }
}

module.exports = PriceAlgorithmItaly;
